/* eslint-disable */
import _ from 'underscore';
import asyncScheduler from '@bingads-webui-static-legacy/async-scheduler';
import odata from '@bingads-webui-component-legacy/http/channel/odata';
import instrumentation from '@bingads-webui-static-legacy/instrumentation/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';
import * as errors from '@bingads-webui-campaign-legacy/instrumentation/error-codes';
import '@bingads-webui-static-legacy/instrumentation/instrumentation';
var urlTemplate = '/Customers()/Accounts()/TaskItemExecutions({{ExecutionId}})';
function handleUpdates(result) {
  var data = result.data || ({});
  this.consecutiveFailureCount = 0;
  var isSucceed = _.contains(['Completed'], data.Status);
  var isInProgress = _.contains(['InProgress', 'PendingExecution'], data.Status);
  var isFailed = !(isSucceed || isInProgress);
  if (isFailed && !_.contains(['Failed', 'RetryNeeded', 'AccessDenied', 'UserError'], data.Status)) {
    instrumentation.logError('UploadConversions/statusPoller/handleUpdates', 'Unexpected status: ' + data.Status + ', treat is as a failure');
  }
  if (isSucceed || isFailed) {
    this.job.stop();
  }
  if (data.RowsProcessed && data.TotalRows) {
    this.options.parentTask.trigger('update', data.RowsProcessed, data.TotalRows);
  }
  if (isSucceed) {
    instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, '/UploadConversions/statusPoller/handleUpdates', 'Finish polling');
    this.options.parentTask.trigger('done', data);
  } else if (isFailed) {
    var trackingid, requestid;
    var xhr = this.lastSuccessXHR || ({});
    if (_.isFunction(xhr.getResponseHeader)) {
      trackingid = xhr.getResponseHeader('x-ms-trackingid');
      requestid = xhr.getResponseHeader('x-ms-requestid');
    }
    this.errorLog = _.extend({}, this.errorLog, _.pick(xhr, 'readyState', 'responseText', 'status', 'statusText'), {
      'x-ms-trackingid': trackingid,
      'x-ms-requestid': requestid
    });
    var isUserError = false;
    try {
      var errorCode = xhr.responseJSON && xhr.responseJSON.Errors[0].Code;
      isUserError = errors.odataErrorCodes.includes(errorCode.toUpperCase());
    } catch (e) {}
    if (!isUserError) {
      instrumentation.logError('UploadConversions/statusPoller/handleUpdates', 'Details:' + JSON.stringify(this.errorLog));
    }
    this.options.parentTask.trigger('error', {
      errorMsgKey: 'UnifiedEventTracking_UploadConversions_GenericError',
      log: this.errorLog,
      isUserError: isUserError
    });
  }
}
function handleFailures(result) {
  var err = result.error || ({});
  this.consecutiveFailureCount++;
  if (this.consecutiveFailureCount >= 5) {
    this.job.stop();
    this.errorLog = _.extend({}, this.errorLog, _.pick(err, 'readyState', 'responseText', 'status', 'statusText'), _.pick(err.headers, 'x-ms-requestid', 'x-ms-trackingid'));
    var isUserError = false;
    var xhr = this.lastSuccessXHR || ({});
    try {
      var errorCode = xhr.responseJSON && xhr.responseJSON.Errors[0].Code;
      isUserError = errors.odataErrorCodes.includes(errorCode);
    } catch (e) {}
    if (!isUserError) {
      instrumentation.logError('UploadConversions/statusPoller/handleFailures', 'Polling failed ' + this.consecutiveFailureCount + ' times. Details: ' + JSON.stringify(this.errorLog));
    }
    this.options.parentTask.trigger('error', {
      errorMsgKey: 'UnifiedEventTracking_UploadConversions_GenericError',
      log: this.errorLog
    });
  }
}
function scheduledTask() {
  var options = {
    success: (function (data, status, xhr) {
      this.lastSuccessXHR = xhr;
    }).bind(this)
  };
  return odata.get(this.url, options);
}
var Poller = function (options) {
  this.options = options || ({});
  this.consecutiveFailureCount = 0;
  this.url = _.template(urlTemplate)({
    ExecutionId: this.options.ExecutionId
  });
  this.job = asyncScheduler.createTask({
    schedule: 2000,
    task: scheduledTask.bind(this),
    overlapping: 'wait'
  });
  this.job.on('success', handleUpdates.bind(this));
  this.job.on('error', handleFailures.bind(this));
  this.errorLog = {
    Url: this.url
  };
};
Poller.prototype.start = function () {
  this.job.start();
};
export default Poller;

